var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('home-header'),_vm._v(" "),_c('carousel-banner'),_vm._v(" "),_c('handle-search'),_vm._v(" "),_c('news'),_vm._v(" "),_c('Advantage'),_vm._v(" "),_c('home-map'),_vm._v(" "),_c('products'),_vm._v(" "),_c('solution'),_vm._v(" "),_c('Partner'),_vm._v(" "),_c('home-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e758d1a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Home/Home.vue
// module id = null
// module chunks = 